// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"940":"27186af0","986":"ada67eb7"}[chunkId] + ".chunk.js";
};